// extracted by mini-css-extract-plugin
export default {"merchantForm":"OnFleetForm_merchantForm__UnqLN","merchantActions":"OnFleetForm_merchantActions__9igDK"};